import {
  schemes,
  zSchema,
  publicPaginationSchema,
  publicSortSchema,
  accrualPolicySchema,
} from "@zeal/common";

export const getAccrualPoliciesRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  q: zSchema.string().optional(),
  policy_type: zSchema.string().optional(),
  ...publicSortSchema.shape,
  ...publicPaginationSchema.shape,
});

export type TGetAccrualPoliciesRequestSchema = zSchema.infer<
  typeof getAccrualPoliciesRequestSchema
>;

export const getAccrualPoliciesResponseSchema = zSchema.array(
  accrualPolicySchema.pick({
    id: true,
    code: true,
    name: true,
    type: true,
    effective_date: true,
    workers_count: true,
  })
);

export type TGetAccrualPoliciesResponseSchema = zSchema.infer<
  typeof getAccrualPoliciesResponseSchema
>;
